import styled, { css } from "styled-components";
import isPlainObject from "lodash.isplainobject";
import { breakpoint } from "@nib/layout";
import { variables } from "@nib-group/chatbot-shared/styles";
export const Wrapper = styled.div`
  position: fixed;
  z-index: ${variables.Z_IDX_INLINE_CHAT_WINDOW};

  ${_ref => {
  let {
    bottom,
    right
  } = _ref;
  return css`
    bottom: ${typeof bottom === "string" ? bottom : bottom === null || bottom === void 0 ? void 0 : bottom.mobile};
    right: ${typeof right === "string" ? right : right === null || right === void 0 ? void 0 : right.mobile};

    ${typeof bottom !== "string" && isPlainObject(bottom) && css`
      ${breakpoint("md")`
				bottom: ${bottom === null || bottom === void 0 ? void 0 : bottom.tablet};
			`}

      ${breakpoint("xl")`
				bottom: ${bottom === null || bottom === void 0 ? void 0 : bottom.desktop};
			`}
    `}

    ${typeof right !== "string" && isPlainObject(right) && css`
      ${breakpoint("md")`
				right: ${right === null || right === void 0 ? void 0 : right.tablet};
			`}

      ${breakpoint("xl")`
				right: ${right === null || right === void 0 ? void 0 : right.desktop};
			`}
    `}
  `;
}}
`;